<script setup lang="ts">
// Centred Back / "page / total" / Next pagination shown below paginated tables.
// Renders nothing when there is only one page.
import { useI18n } from 'vue-i18n'

defineProps<{
  currentPage: number
  totalPages: number
}>()

const emit = defineEmits<{
  change: [page: number]
}>()

const { t } = useI18n()
</script>

<template>
  <div v-if="totalPages > 1" class="flex items-center justify-center gap-2 mt-6">
    <button
      type="button"
      :disabled="currentPage <= 1"
      class="text-sm text-slate-400 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed px-3 py-1.5 rounded-lg border border-slate-700 hover:border-slate-600 transition-colors"
      @click="emit('change', currentPage - 1)"
    >
      {{ t('common.back') }}
    </button>
    <span class="text-sm text-slate-400">{{ currentPage }} / {{ totalPages }}</span>
    <button
      type="button"
      :disabled="currentPage >= totalPages"
      class="text-sm text-slate-400 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed px-3 py-1.5 rounded-lg border border-slate-700 hover:border-slate-600 transition-colors"
      @click="emit('change', currentPage + 1)"
    >
      {{ t('common.next') }}
    </button>
  </div>
</template>
